import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, DisplayText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const BundleIncluded = (props: Props) => {
  const { children, selectedCount } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <DisplayText sizeMatch={HEADER_SIZE_MATCH} style={styles.headerText} bold>
          <FormattedMessage {...messages.title} />
        </DisplayText>

        <View style={styles.badge}>
          <BodyText sizeMatch={BADGE_SIZE_MATCH} style={styles.badgeText}>
            {selectedCount}
          </BodyText>
        </View>
      </View>

      <View style={styles.slots}>{children}</View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const BADGE_SIZE = 24;
const HEADER_TEXT_TOP_NUDGE = 3;

const HEADER_SIZE_MATCH: ComponentProps<typeof DisplayText>['sizeMatch'] = ['24'];
const BADGE_SIZE_MATCH: ComponentProps<typeof BodyText>['sizeMatch'] = ['16'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing['4'],
    paddingTop: theme.spacing['6'],
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['2'],
    paddingHorizontal: theme.spacing['6'],
  },
  headerText: {
    marginTop: HEADER_TEXT_TOP_NUDGE,
    color: theme.colors.KALE,
  },
  badge: {
    alignItems: 'center',
    justifyContent: 'center',
    width: BADGE_SIZE,
    height: BADGE_SIZE,
    borderRadius: BADGE_SIZE / 2,
    backgroundColor: theme.colors.KALE,
  },
  badgeText: {
    color: theme.colors.WHITE,
  },
  slots: {
    gap: theme.spacing['2'],
    paddingHorizontal: theme.spacing['4'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Included',
    description: 'Bundle | Included section | Title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  selectedCount: number;
}>;
